import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Row, Col, UncontrolledPopover, PopoverHeader, PopoverBody, Card, CardBody, FormGroup, Label, Input, CardHeader, CardTitle, Button, Badge } from 'reactstrap';
import * as commonFunc from 'scripts/common';

import Swal from "sweetalert2";
import moment from "moment";
import sanitizeHtml from 'sanitize-html';

import { useTranslation } from "react-i18next";

import { withRouter } from 'components/withRouter';

import DPCustom from '../../components/DPCustom';
import Cleave from 'cleave.js/react';

class SearchSessions extends Component {
    static displayName = SearchSessions.name;

    constructor(props) {
        super(props);

        this.state = {
            searchResults: [], activitiesFilters: [], durationFilter: -1, flexibilityFilter: "3D", searchDate: moment().utc().add(1, "days").startOf("day").toDate(), adultsCount: 1, childsCount: 0,
            targetFilter: 0, expFilter: -1, physFilter: -1, natFilter: -1, claustroFilter: -1, vertigoFilter: -1,
            activitiesFiltersCollapsed: true, durationFilterCollapsed: true, dateFiltersCollapsed: false, ptcpFiltersCollapsed: true, profilFiltersCollapsed: true
        };
    }

    componentDidMount() {
        //console.debug("mount");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function () {
            //init

            /*commonFunc.postMethod("https://facesud.softena.com/api/ApiSync/LoadFilters", { lang: "fr" }).then(response => {
                var data = response.data;
                if (data.isSuccess) {

                }
                else {

                }
            });*/

        });

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //if (this.props.searchParams !== prevProps.searchParams) {
            //change searchParams
        //}
    }

    startSearch() {
        var context = this;
        context.setState({ searchResults: [], searching: true });

        var activityTypes = [{ ActID: 0, Title: "Toutes" }, { ActID: 5, Title: "Canyoning" }, { ActID: 13, Title: "Via Ferrata" }, { ActID: 7, Title: "Escalade" }, { ActID: 9, Title: "Via Cordata" }, { ActID: 11, Title: "Spéléologie" },
        { ActID: 3, Title: "Canoë Encadré" }, { ActID: 17, Title: "Location Canoë" }, { ActID: 20, Title: "Location Vélo Electrique" }, { ActID: 21, Title: "Location Vélo Musculaire" }, { ActID: 19, Title: "Location Vélo Parcours GPS" }];

        var args = {};
        args.ActID = -1; //Filtre activité ex:31
        if (context.state.targetFilter > 0) args.CliTarget = context.state.targetFilter; //Filtre Type Client ex:18
        args.StartDate = context.state.searchDate.toISOString(); //Date de début de recherche (attention UTC "YYYY-MM-DDT00:00:00.000Z")
        args.PeriodID = context.state.flexibilityFilter; //Flexibilité 0D, 1D , 2D, 3D, 1W, 2W,  1M, 1Y
        args.CycleID = context.state.durationFilter; // Cycle Journée , Demi-journée etc ex:4


        if (context.state.activitiesFilters.length <= 0 || context.state.activitiesFilters.indexOf(0) >= 0) {
            args.TypeAct = activityTypes.filter(act => act.ActID !== 0).map(act => act.ActID);
        }
        else args.TypeAct = context.state.activitiesFilters; //*Obligatoire Type d’activité ex [5,3]
        args.CliCountAPax = context.state.adultsCount || 1;//Nombre Adultes
        args.CliCountCPax = context.state.childsCount; //Nombre Enfants
        args.Lang = "FR";

        args.BenDifficulty = -1; //Difficulé
        args.BenSportivity = -1;//Sportivité   
        args.BenTechnicity = -1; //Technicité Non Utilisé

        if (context.state.physFilter >= 0) args.CliPhysCond = context.state.physFilter; //Condition Physique
        if (context.state.expFilter >= 0) args.CliExpCond = context.state.expFilter; //Expérience
        if (context.state.vertigoFilter >= 0) args.CliVertigoCond = context.state.vertigoFilter; //Tolérance Vertige
        if (context.state.natFilter >= 0) args.CliNatCond = context.state.natFilter; //Aisance Aquatique
        if (context.state.claustroFilter >= 0) args.CliClaustroCond = context.state.claustroFilter; //Tolérance Claustro

        commonFunc.postMethod("../api/site/FacesudJob", args).then(response => {
            var data = response.data;
            if (data.isSuccess) {
                context.setState({ searchResults: (data.result || []), searching: false });
            }
            else context.setState({ searching: false });
        });
    }

    updateCount(value, modificator, type) {
        var newValue = value + modificator;
        if (newValue >= 0) {
            switch (type) {
                case "adults":
                    this.setState({ adultsCount: newValue });
                    break;
                case "childs":
                    this.setState({ childsCount: newValue });
                    break;
                default: break;
            }
        }
    }

    profilInfos(value, type) {
        switch (type) {
            case "exp":
            case "nat":
            case "claustro":
            case "vertigo":
                switch (true) {
                    case value >= 85:
                        return { value: 3, label: "Bonne" };
                    case value >= 60:
                        return { value: 2, label: "Moyenne" };
                    case value >= 35:
                        return { value: 1, label: "Faible" };
                    case value >= 15:
                        return { value: 0, label: "Aucune" };
                    default:
                        return { value: -1, label: "Peu importe" };
                }
            case "phys":
                switch (true) {
                    case value >= 85:
                        return { value: 3, label: "Très Bonne" };
                    case value >= 60:
                        return { value: 2, label: "Bonne" };
                    case value >= 35:
                        return { value: 1, label: "Moyenne" };
                    case value >= 15:
                        return { value: 0, label: "Faible" };
                    default:
                        return { value: -1, label: "Peu importe" };
                }
            default:
                return { value: -1, label: "Peu importe" };
        }
    }

    profilValue(state) {
        switch (state) {
            case 3: return 85;
            case 2: return 60;
            case 1: return 35;
            case 0: return 15;
            default: return 0;
        }
    }

    render() {
        var context = this;
        var lightMode = true;

        console.debug(this.state.searchResults);

        var styleComp = <style>
            {`
                .main-panel > .content:has(#search-sessions) {
                  display: flex;
                  height: calc(100vh - 123px);
                }
                main.container-true:has(#search-sessions) {
                  flex: auto;
                }

                .card-filters {
                    min-height: 450px;
                    max-height: 100%;
                    overflow-x: hidden;
                    overflow-y: auto;
                }
                .card-filters .filter-title:hover, .card-filters .filter-title:hover i {
                    color: #00AAA8 !important;
                }
                .filter-title i {
                    width: 10px;
                    flex: auto;
                }
                .filter-date .filter-input > .react-datepicker-wrapper {
                    width: 100%;
                }
                .filter-list .form-check-label {
                    cursor: pointer;
                }
                .filter-list .form-check-label span:not(.form-check-sign) {
                    font-size: 16px;
                    opacity: 0.7;
                    transition: .2s opacity;
                }
                .filter-list .form-check-label input:checked + span + span {
                    opacity: 1;
                }
                .filter-list .form-check-label span:not(.form-check-sign):hover {
                    opacity: 1;
                }
            `}
        </style>;

        //Filters >> TODO : LoadFilters ???
        var iconsActivities = { 5: "fa-mountain", 13: "fa-mountain", 7: "fa-mountain", 9: "fa-mountain", 11: "fa-mountain", 3: "fa-ship", 17: "fa-ship", 20: "fa-bicycle", 21: "fa-bicycle", 19: "fa-bicycle" };

        var activityTypes = [{ ActID: 0, Title: "Toutes" }, { ActID: 5, Title: "Canyoning" }, { ActID: 13, Title: "Via Ferrata" }, { ActID: 7, Title: "Escalade" }, { ActID: 9, Title: "Via Cordata" }, { ActID: 11, Title: "Spéléologie" },
            { ActID: 3, Title: "Canoë Encadré" }, { ActID: 17, Title: "Location Canoë" }, { ActID: 20, Title: "Location Vélo Electrique" }, { ActID: 21, Title: "Location Vélo Musculaire" }, { ActID: 19, Title: "Location Vélo Parcours GPS" }];

        var durationTypes = [{ Title: "Peu m'importe", CycleID: -1 }, { Title: "Demi-Journée", CycleID: 2 }, { Title: "Journée", CycleID: 4 }, { Title: "Soirée", CycleID: 8 }, { Title: "Week-end 1 à 2 nuit(s)", CycleID: 96 }, { Title: "Séjour + de 2 nuits", CycleID : 896 }];

        var flexibilities = [{ Title: "+/- 1 jour", PeriodID: "1D" }, { Title: "+/- 2 jours", PeriodID: "2D" }, { Title: "+/- 3 jours", PeriodID: "3D" }, { Title: "+/- 1 semaine", PeriodID: "1W" }, { Title: "+/- 2 semaines", PeriodID: "2W" },];

        var profilTargets = [{ Title: "Peu m'importe", Value: "0" }, { Title: "Entre amis", Value: "3" }, { Title: "En famille", Value: "1" }, { Title: "Un couple", Value: "4" }, { Title: "Je suis seul", Value: "5" },
            { Title: "Un Enterrement de vie de célibataire", Value: "6" }, { Title: "Une collectivité", Value: "10" }, { Title: "Un établissement scolaire", Value: "11" }, { Title: "Un Comité d'Entreprise", Value: "13" },
            { Title: "Une organisation étudiante", Value: "15" }, { Title: "Un club ", Value: "17" }, { Title: "Une entreprise", Value: "18" }];

        return <div id="search-sessions" className="h-100 d-flex flex-column">
            {styleComp}
            <div className="ms-2 fw-bold"><span className="fs-5" style={{ color: "#ef6060" }}>{this.state.searchResults?.length || 0}</span> activités correspondent à vos critères</div>
            <Row className="h-100" style={{ maxWidth: "1400px", minWidth: "100%", alignSelf: "center", flex: "auto" }}>
                <Col className="h-100" xs="3" xl="4">
                    <Card className="card-filters">
                        <CardBody>
                            <div className="filter-activities">
                                <div className="filter-title d-flex cursor-pointer align-items-center mb-2" onClick={() => { this.setState({ activitiesFiltersCollapsed: !this.state.activitiesFiltersCollapsed }); } }>
                                    <h6 className="m-0">Type d'activité</h6>
                                    {this.state.activitiesFiltersCollapsed ? <i className="fa fa-angle-down ms-1 text-muted text-end"></i> : <i className="fa fa-angle-up ms-1 text-muted text-end"></i>}
                                </div>

                                {!this.state.activitiesFiltersCollapsed && <div className="text-end">
                                    <Row className="filter-list">
                                        {activityTypes.map(activity => <Col xs="6"><FormGroup check className='fcheck-sm text-start mb-0'>
                                            <Label check>
                                                <Input checked={context.state.activitiesFilters.indexOf(activity.ActID) >= 0} type="checkbox" onChange={(e) => {
                                                    var newFilters = context.state.activitiesFilters || [];
                                                    if (e.target.checked) newFilters.push(activity.ActID);
                                                    else newFilters = newFilters.filter(filter => filter !== activity.ActID);
                                                    context.setState({ activitiesFilters: newFilters });
                                                }} />
                                                <span className="form-check-sign" />
                                                <span>{activity.Title}</span>
                                            </Label>
                                        </FormGroup></Col>)}
                                    </Row>
                                    <Button color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { this.startSearch(); }}>Valider</Button>
                                </div>}
                            </div>
                            <div className="hr-line-dashed" />
                            <div className="filter-duration">
                                <div className="filter-title d-flex cursor-pointer align-items-center mb-2" onClick={() => { this.setState({ durationFilterCollapsed: !this.state.durationFilterCollapsed }); }}>
                                    <h6 className="m-0">Durée</h6>
                                    {this.state.durationFilterCollapsed ? <i className="fa fa-angle-down ms-1 text-muted text-end"></i> : <i className="fa fa-angle-up ms-1 text-muted text-end"></i>}
                                </div>

                                {!this.state.durationFilterCollapsed && <div className="text-end">
                                    <Row className="filter-list">
                                        {durationTypes.map(durationFilter => <Col xs="6"><div className='form-check-radio fcheck-sm text-start'>
                                            <Label check>
                                                <Input name="durationFilter" type="radio" checked={context.state.durationFilter === durationFilter.CycleID} value={durationFilter.CycleID} onChange={(e) => {
                                                    context.setState({ durationFilter: parseInt(e.target.value) });
                                                }} />
                                                <span className="form-check-sign" />
                                                <span>{durationFilter.Title}</span>
                                            </Label>
                                        </div></Col>)}
                                    </Row>
                                    <Button color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { this.startSearch(); }}>Valider</Button>
                                </div>}
                            </div>
                            <div className="hr-line-dashed" />
                            <div className="filter-date">
                                <div className="filter-title d-flex cursor-pointer align-items-center mb-2" onClick={() => { this.setState({ dateFiltersCollapsed: !this.state.dateFiltersCollapsed }); }}>
                                    <h6 className="m-0">Date / Flexibilité</h6>
                                    {this.state.dateFiltersCollapsed ? <i className="fa fa-angle-down ms-1 text-muted text-end"></i> : <i className="fa fa-angle-up ms-1 text-muted text-end"></i>}
                                </div>

                                {!this.state.dateFiltersCollapsed && <div className="text-end">
                                    <DPCustom parentClassName="filter-input mb-2"
                                        className={"form-control form-control-sm"}
                                        showWeekNumbers={false}
                                        dateFormat="dd/MM/yyyy"
                                        timeFormat={false}
                                        locale="fr"
                                        placeholderText="__/__/____"
                                        autoComplete="off" aria-autocomplete="none"
                                        selected={context.state.searchDate}
                                        invalid={false}
                                        onChange={(date) => {
                                            context.setState({ searchDate: date });
                                        }}
                                        customInput={
                                            <Cleave autoComplete="off" aria-autocomplete="none" options={{ date: true, delimiter: '/', datePattern: ['d', 'm', 'Y'] }} />
                                        } />
                                    <Row className="filter-list">
                                        {flexibilities.map(flexibility => <Col xs="6"><div className='form-check-radio fcheck-sm text-start'>
                                            <Label check>
                                                <Input name="flexibilityFilter" type="radio" checked={context.state.flexibilityFilter === flexibility.PeriodID} value={flexibility.PeriodID} onChange={(e) => {
                                                    context.setState({ flexibilityFilter: e.target.value });
                                                }} />
                                                <span className="form-check-sign" />
                                                <span>{flexibility.Title}</span>
                                            </Label>
                                        </div></Col>)}
                                    </Row>
                                    <Button color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { this.startSearch(); }}>Valider</Button>
                                </div>}
                            </div>
                            <div className="hr-line-dashed" />
                            <div className="filter-ptcp">
                                <div className="filter-title d-flex cursor-pointer align-items-center mb-2" onClick={() => { this.setState({ ptcpFiltersCollapsed: !this.state.ptcpFiltersCollapsed }); }}>
                                    <h6 className="m-0">Participants</h6>
                                    {this.state.ptcpFiltersCollapsed ? <i className="fa fa-angle-down ms-1 text-muted text-end"></i> : <i className="fa fa-angle-up ms-1 text-muted text-end"></i>}
                                </div>

                                {!this.state.ptcpFiltersCollapsed && <div className="text-end">
                                    <div className="text-start w-75 ms-4">
                                        <div className="adults-container d-flex justify-content-between">
                                            <div className="labels-part align-content-center">
                                                <div><b>Adultes</b></div>
                                                <span className="text-muted">15 ans et plus</span>
                                            </div>
                                            <div>
                                                <Button className="btn-icon rounded-circle btn-simple me-2" size="sm" color="dark" onClick={() => { context.updateCount(context.state.adultsCount, -1, "adults"); }}><i className="fa fa-minus"></i></Button>
                                                {context.state.adultsCount}
                                                <Button className="btn-icon rounded-circle btn-simple ms-2" size="sm" color="dark" onClick={() => { context.updateCount(context.state.adultsCount, 1, "adults"); }}><i className="fa fa-plus"></i></Button>
                                            </div>
                                        </div>
                                        <div className="childs-container d-flex justify-content-between">
                                            <div className="labels-part align-content-center">
                                                <div><b>Enfants</b></div>
                                                <span className="text-muted">Moins de 15 ans</span>
                                            </div>
                                            <div>
                                                <Button className="btn-icon rounded-circle btn-simple me-2" size="sm" color="dark" onClick={() => { context.updateCount(context.state.childsCount, -1, "childs"); }}><i className="fa fa-minus"></i></Button>
                                                {context.state.childsCount}
                                                <Button className="btn-icon rounded-circle btn-simple ms-2" size="sm" color="dark" onClick={() => { context.updateCount(context.state.childsCount, 1, "childs"); }}><i className="fa fa-plus"></i></Button>
                                            </div>
                                        </div>
                                    </div>
                                    <Button color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { this.startSearch(); }}>Valider</Button>
                                </div>}
                            </div>
                            <div className="hr-line-dashed" />
                            <div className="filter-profil">
                                <div className="filter-title d-flex cursor-pointer align-items-center mb-2" onClick={() => { this.setState({ profilFiltersCollapsed: !this.state.profilFiltersCollapsed }); }}>
                                    <h6 className="m-0">Profil / Aptitudes</h6>
                                    {this.state.profilFiltersCollapsed ? <i className="fa fa-angle-down ms-1 text-muted text-end"></i> : <i className="fa fa-angle-up ms-1 text-muted text-end"></i>}
                                </div>

                                {!this.state.profilFiltersCollapsed && <div className="text-end">
                                    <Row className="filter-list text-start">
                                        <FormGroup className="mb-0">
                                            <Input type="select" defaultValue={context.state.targetFilter} onChange={(e) => {
                                                context.setState({ targetFilter: parseInt(e.target.value) });
                                            }}>
                                                {profilTargets.map(target => <option value={target.Value}>{target.Title}</option>)}
                                            </Input>
                                        </FormGroup>

                                        <FormGroup className="mb-0">
                                            <Label className="fw-bold" for={"rangeExp"}>Expérience</Label>
                                            <Input id={"rangeExp"} type="range" defaultValue={context.profilValue(context.state.expFilter) || 0} onChange={(event) => {
                                                var newValue = context.profilInfos(event.target.value, "exp").value;
                                                if (newValue !== context.state.expFilter) context.setState({ expFilter: newValue });
                                            }} />   
                                            <Label className="text-muted" for={"rangeExp"}>{context.profilInfos(context.profilValue(context.state.expFilter), "exp").label}</Label>
                                        </FormGroup>
                                        <FormGroup className="mb-0">
                                            <Label className="fw-bold" for={"rangePhys"}>Conditions physique</Label>
                                            <Input id={"rangePhys"} type="range" defaultValue={context.profilValue(context.state.physFilter) || 0} onChange={(event) => {
                                                var newValue = context.profilInfos(event.target.value, "phys").value;
                                                if (newValue !== context.state.physFilter) context.setState({ physFilter: newValue });
                                            }} />
                                            <Label className="text-muted" for={"rangePhys"}>{context.profilInfos(context.profilValue(context.state.physFilter), "phys").label}</Label>
                                        </FormGroup>
                                        <FormGroup className="mb-0">
                                            <Label className="fw-bold" for={"rangeNat"}>Aisance Aquatique</Label>
                                            <Input id={"rangeNat"} type="range" defaultValue={context.profilValue(context.state.natFilter) || 0} onChange={(event) => {
                                                var newValue = context.profilInfos(event.target.value, "nat").value;
                                                if (newValue !== context.state.natFilter) context.setState({ natFilter: newValue });
                                            }} />
                                            <Label className="text-muted" for={"rangeNat"}>{context.profilInfos(context.profilValue(context.state.natFilter), "nat").label}</Label>
                                        </FormGroup>
                                        <FormGroup className="mb-0">
                                            <Label className="fw-bold" for={"rangeClaustro"}>Tolérance Claustro</Label>
                                            <Input id={"rangeClaustro"} type="range" defaultValue={context.profilValue(context.state.claustroFilter) || 0} onChange={(event) => {
                                                var newValue = context.profilInfos(event.target.value, "claustro").value;
                                                if (newValue !== context.state.claustroFilter) context.setState({ claustroFilter: newValue });
                                            }} />
                                            <Label className="text-muted" for={"rangeClaustro"}>{context.profilInfos(context.profilValue(context.state.claustroFilter), "claustro").label}</Label>
                                        </FormGroup>
                                        <FormGroup className="mb-0">
                                            <Label className="fw-bold" for={"rangeVertigo"}>Tolérance Vertige</Label>
                                            <Input id={"rangeVertigo"} type="range" defaultValue={context.profilValue(context.state.vertigoFilter) || 0} onChange={(event) => {
                                                var newValue = context.profilInfos(event.target.value, "vertigo").value;
                                                if (newValue !== context.state.vertigoFilter) context.setState({ vertigoFilter: newValue });
                                            }} />
                                            <Label className="text-muted" for={"rangeVertigo"}>{context.profilInfos(context.profilValue(context.state.vertigoFilter), "vertigo").label}</Label>
                                        </FormGroup>

                                    </Row>
                                    <Button color="danger" style={{ backgroundColor: "#00AAA8", borderRadius: "25px" }} onClick={() => { this.startSearch(); }}>Valider</Button>
                                </div>}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col className="h-100" xs="9" xl="8">
                    <div className="search-results h-100 px-1 pe-2 position-relative" style={{ overflowX: "hidden", overflowY: "auto" }}>
                        {this.state.searching ? <div className="position-absolute" style={{ left:0, right:0, top:0, bottom:0, placeSelf: "center" }}><i className="fa fa-circle-notch fa-spin fa-5x"></i></div>
                            : (this.state.searchResults.length <= 0 ? <div className="fs-6 text-center mt-3">
                            <div className="fw-bold mb-3">Aucun résultat</div>
                            <div className="mb-3">Des difficultés pour réserver? Appelle-nous vite au <a href="tel:+33 4 75 87 27 23" className="fw-bold" style={{ color: "#00AAA8" }}>+33 (0)4 75 87 27 23</a>, nous te trouverons une dispo à ta convenance.</div>
                            <div className="fw-bold mb-3">Tous les créneaux ne sont pas ouverts à la réservation en ligne.</div>
                            <div className="mb-3">Pour les activités groupes, les séjours, nous t'invitons aussi à nous appeler au <a href="tel:+33 4 75 87 27 23" className="fw-bold" style={{ color: "#00AAA8" }}>+33 (0)4 75 87 27 23</a>.</div>
                        </div> : "")}
                        {this.state.searchResults?.map((rowData, index) => {

                            var desc = sanitizeHtml(rowData.AdditionnalInfos?.Title, {
                                allowedTags: [],
                                allowedAttributes: {}
                            });

                            //var diffDays = moment(rowData.StartDate).startOf("day").diff(moment(context.state.searchDate).startOf("day"), 'days');
                            var diffDays = parseInt(rowData.DiffDays);
                            //var diffDays = Math.round(rowData.DiffDays);
                            //console.debug(rowData);
                            return <NavLink to={`/ShowSession?ID=${rowData.ID}&ActID=${rowData.ActID}`} className="nav-link">
                                <Card key={"searchItem" + index} className={`mt-2 widget-magnify overflow-hidden cursor-pointer widget dash flex-row ${lightMode ? "" : "text-light"}`} style={lightMode ? { minHeight: "192px", maxHeight: "250px" } : { background: "rgba(30, 89, 115, 0.95)" }}>

                                    <div class="d-flex text-center" style={{ widthOLD: "280px", width: "calc(8vw + 130px)", placeContent: "center", overflow: "clip" }}>
                                        <img className="float-start" style={{ height: "100%" }} src={rowData.ResAvatar.replace("../api/ApiSync/DownloadPublicFile", "https://facesud.softena.com/Booking/DownloadFile")} alt="Avatar" />
                                    </div>
                                    <div className="d-flex flex-column" style={{ flex: "auto" }}>
                                        <CardHeader className="p-0">
                                            <div className="d-flex">
                                                <div className="flex-fill w-75 ps-3 pt-3">
                                                    <CardTitle tag="h6" className={`m-0 2w-75 searchParams ${lightMode ? "" : "text-light"}`} title={rowData.TypeActName + " " + rowData.CycleName} style={{ color: "#00AAA8" }}>{rowData.TypeActName + " " + rowData.CycleName}</CardTitle>
                                                    <CardTitle tag="h5" className={`m-0 2w-75 searchParams fw-bold ${lightMode ? "" : "text-light"}`} title={rowData.AdditionnalInfos?.Name}>{rowData.AdditionnalInfos?.Name}</CardTitle>
                                                </div>
                                                <div className="flex-fill pe-3 pt-3 d-none">
                                                    Info
                                                </div>
                                            </div>
                                            <div className="widget-tools collapse-tool">
                                                <div data-name="GroupFrag" data-element="group" className=" p-0 col-auto">
                                                    <div className="row" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                                        <div data-name="TextViewFrag" data-element="textview" className="d-inline-block mb-3 p-0 col-auto">
                                                            <div className="  m-0 row-cols-lg-auto2 align-items-center form-group m-0 "><i className={`fa ${iconsActivities[rowData.TypeActID]}`} style={{ marginTop: "25px", color: (lightMode ? "rgb(120, 120, 120)" : "rgb(255, 255, 255)"), fontSize: "65px" }}></i></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardHeader>
                                        <CardBody className="d-flex flex-column pt-0">
                                            <div className="mt-1 searchParams line3-ellipsis fst-italic" title={desc} style={{ fontSize: "14px", flex: "auto" }}>{desc}</div>
                                            <div className="d-flex pt-2">
                                                <div className="need-part pe-2" style={{ borderRight: "1px solid grey", width: "100px" }}>
                                                    <h6>Pré-requis</h6>
                                                    {rowData.Constraints?.CliMinAge ? <div className="badge bg-secondary d-inline-block me-2 mt-1 pt-1" style={{ verticalAlign: "top" }}>+{rowData.Constraints.CliMinAge}ans</div> : ""}
                                                    {rowData.Constraints?.CliNatCond ? <div className="d-inline-block text-muted" style={{ lineHeight: "1" }}>Savoir<br />Nager</div> : ""}
                                                </div>
                                                <div className="date-part px-2" style={{ flex: "auto" }}>
                                                    <h6>Dates</h6>
                                                    {rowData.CatName !== "LOC" ? <>
                                                        <div className="pe-2 fw-bold">
                                                            <span style={{ color: "#ef6060" }}>{moment(commonFunc.restStringToDate(rowData.StartDate)).utc(true).format("DD MMMM YYYY")}</span>
                                                            <span className="text-muted"> - {sanitizeHtml(rowData.SubCycleName, {
                                                                allowedTags: [],
                                                                allowedAttributes: {}
                                                            }).toLowerCase()}</span>
                                                        </div>
                                                        {diffDays !== 0 ? <div style={{ color: "#00AAA8" }}><b>Flexibilité</b> : {diffDays > 0 ? ("+" + diffDays) : diffDays} jour(s)</div> : ""}
                                                    </> : <div>
                                                        <div className="pe-2 text-muted">
                                                            du <span className="fw-bold" style={{ color: "#ef6060" }}>{moment(commonFunc.restStringToDate(rowData.StartDate)).utc(true).format("DD/MM/YYYY")}</span>
                                                            &nbsp;au <span className="fw-bold" style={{ color: "#ef6060" }}>{moment(commonFunc.restStringToDate(rowData.EndDate)).utc(true).format("DD/MM/YYYY")}</span>
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="price-part">
                                                    <h6>à partir de</h6>
                                                    <div style={{ color: "#00AAA8" }}><span className="fw-bold" style={{ fontSize: "25px" }}>{rowData.CPrices[0].PriceA} €</span> / pers</div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </div>
                                </Card>
                            </NavLink>;
                        })}
                    </div>
                </Col>
            </Row>
        </div>;

        /*{this.state.searchResults?.map((rowData, index) => <Card key={"searchItem" + index} className={`mt-2 widget-magnify overflow-hidden widget dash ${lightMode ? "" : "text-light"}`} style={lightMode ? { minHeight: "192px", maxHeight: "192px" } : { background: "rgba(30, 89, 115, 0.95)" }} onClick={onClick}>
                            <CardHeader className="p-0">
                                <div className="d-flex">
                                    <div class="text-center ms-2 mt-1 d-none2">
                                        <img className="ui-icon-64 ui-icon-row2 rounded float-start" src={(() => { return rowData.ResAvatar.replace("../api/ApiSync/DownloadPublicFile", "https://facesud.softena.com/Booking/DownloadFile"); })()} alt="Avatar" />
                                    </div>
                                    <div className="flex-fill w-75 ps-3 pt-3">
                                        <CardTitle tag="h6" className={`m-0 w-75 searchParams ${lightMode ? "" : "text-light"}`} title={rowData.TypeActName + " " + rowData.CycleName}>{rowData.TypeActName + " " + rowData.CycleName}</CardTitle>
                                        <CardTitle tag="h5" className={`m-0 w-75 searchParams fw-bold ${lightMode ? "" : "text-light"}`} title={rowData.AdditionnalInfos?.Name}>{rowData.AdditionnalInfos?.Name}</CardTitle>
                                    </div>
                                    <div className="flex-fill pe-3 pt-3">
                                        Info
                                    </div>
                                </div>
                                <div className="widget-tools collapse-tool">
                                    <div data-name="GroupFrag" data-element="group" className=" p-0 col-auto">
                                        <div className="row" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                            <div data-name="TextViewFrag" data-element="textview" className="d-inline-block mb-3 p-0 col-auto">
                                                <div className="  m-0 row-cols-lg-auto2 align-items-center form-group m-0 "><i className={`fa fa-wheat-awn-circle-exclamation`} style={{ marginTop: "25px", color: (lightMode ? "rgb(120, 120, 120)" : "rgb(255, 255, 255)"), fontSize: "65px" }}></i></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="pt-2">
                                <div className="d-flex">
                                    <div className="pe-2 fw-bold text-secondary">{moment(commonFunc.restStringToDate(rowData.StartDate)).utc(true).format("DD MMMM YYYY")}</div>
                                    <div className="pe-2">{rowData.chrono} - {rowData.categ} {rowData.stype}</div>
                                    <div className="text-decoration-underline text-truncate" style={{ maxWidth: "55%" }} title={rowData.reference}>Réf : {rowData.reference}</div>
                                    {(commonFunc.isBlank(rowData.fichier_pdf) || (rowData.fichier_pdf?.endsWith && rowData.fichier_pdf.endsWith("&fileName="))) ? <div class="text-center ms-2" style={{}}>
                                        <a target="_blank" href={rowData.lien_pdf}><i class={`fa fa-file-pdf fa-lg ${lightMode ? "" : "text-light"}`}></i></a>
                                    </div> : <div class="text-center ms-2">
                                        <a target="_blank" href={rowData.fichier_pdf}><i class={`fa fa-file-pdf fa-lg ${lightMode ? "" : "text-light"}`}></i></a>
                                    </div>}
                                    <div className="flex-fill"></div>
                                </div>
                                <div className="mt-1 searchParams line3-ellipsis fst-italic" style={{ fontSize: "14px" }}>{sanitizeHtml(rowData.AdditionnalInfos?.Title, {
                                    allowedTags: [],
                                    allowedAttributes: {}
                                })}</div>
                            </CardBody>
                        </Card>)} */
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(SearchSessions));